<template>
  <div class="checkout-address">
    <div v-if="addresses.length">
      <SfSelect
        :key="addresses.length"
        v-model="address"
        :value="address"
        :placeholder="$t('Select option')"
        @input="updateField('address', $event)"
        :label="$t('Address')"
        class="sf-select--underlined"
        :disabled="showNewAddress"
      >
        <SfSelectOption
          v-for="addressItem in addresses"
          :key="addressItem.Id"
          :value="addressItem.Id"
        >
          {{ addressItem.FirstName }} -
          {{ addressItem.LastName }} -
          {{ addressItem.Address1 }} -
          {{ addressItem.City }} -
          {{ getCountryAndStateToName('countries', addressItem.CountryId) }}
        </SfSelectOption>
      </SfSelect>
      <div v-if="showNewAddressCheckobox">
        <SfCheckbox
          v-model="showNewAddress"
          name="new-address"
          :label="$t('New Address')"
        />
      </div>
    </div>
    <div v-if="showNewAddress || !addresses.length">
      <EditAddress
        :address="newAddress"
        :showCancelButton="false"
        @submitAddress="updateField('newAddress', $event)"
      />
    </div>
  </div>
</template>
<script>
import {
  SfSelect,
  SfCheckbox,
} from '@storefront-ui/vue';
import { EditAddress } from '@/modules/user';
import { config } from '@/modules/core';

export default {
  name: 'CheckoutAddress',
  mixins: [config],
  components: {
    SfSelect,
    SfCheckbox,
    EditAddress,
  },
  props: {
    addresses: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    newAddressPreselected: {
      type: Boolean,
      default: false,
    },
    showNewAddressCheckobox: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      address: '',
      showNewAddress: this.newAddressPreselected,
      newAddress: undefined,
    };
  },
  watch: {
    value: {
      handler() {
        this.showNewAddress = false;
        this.address = this.value.address;
        this.newAddress = this.value.newAddress;
      },
      immediate: true,
    },
  },
  methods: {
    updateField(fieldName, fieldValue) {
      this.$emit('input', {
        ...this.value,
        [fieldName]: fieldValue,
      });
    },
  },
};
</script>
<style lang="scss" scoped>

.sf-button,
.sf-input,
.sf-checkbox {
  margin-bottom: var(--spacer-sm);
}

</style>
